export const kitchens = [
  {
    id: "0006",
    name: "Cozinha Pompéia",
    description: [
      "Uma cozinha em que nasce um ambiente desafogado e convidativo, onde os tons quentes predominam e criam uma atmosfera calorosa e acolhedora.\nCom um design que imagina Pompéia, esta cozinha é um oásis de calor, história e beleza, onde a madeira e a simplicidade evocam a envolvente deslumbrante da antiga cidade romana.",
      "A ilha oferece uma espaçosa superfície de trabalho, ideal para preparar alimentos e servir refeições.\nDispõe ainda de um balcão de madeira maciça, dando um toque de elegância natural. Uma adição atraente e prática para qualquer cozinha.",
      "A cozinha faz sublinhar a amplitude entre a sala de estar e o resto da casa, marcando, desta forma, o bem-estar e conforto que proporciona.",
    ],
    highlight: `/assets/kitchen/0006/web_01.jpg`,
    assets: [
      `/assets/kitchen/0006/web_01.jpg`,
      `/assets/kitchen/0006/web_02.jpg`,
      `/assets/kitchen/0006/web_03.jpg`,
      `/assets/kitchen/0006/web_04.jpg`,
      `/assets/kitchen/0006/web_05.jpg`,
      `/assets/kitchen/0006/web_06.jpg`,
      `/assets/kitchen/0006/web_07.jpg`,
      `/assets/kitchen/0006/web_08.jpg`,
      `/assets/kitchen/0006/web_09.jpg`,
      `/assets/kitchen/0006/web_10.jpg`,
    ],
  },
  {
    id: "0008",
    name: "Cozinha Santorini",
    description: [
      "Dominada pela cor branca no seu carácter mais puro, esta cozinha cultiva uma atmosfera de tranquilidade e paz, onde cada detalhe foi cuidadosamente projetado para oferecer um refúgio de bem-estar e conforto. O espaço, que lembra a ilha de Santorini pela sua cor e luz natural, é a cozinha dos seus sonhos no expoente máximo do que é a serenidade e elegância.",
      "As paredes que refletem a luz ampliam o espaço, dando, assim, uma sensação de frescura à cozinha. Além disso, é uma combinação de elementos que proporciona o positivo da simplicidade, que visa estimular momentos descontraídos e refeições tranquilas.",
      "Ilha em calacatta gold, fresca ao toque, criando, desta forma, um brilho natural que dá vida ao ambiente que a envolve.",
    ],
    highlight: `/assets/kitchen/0008/01.jpeg`,
    assets: [
      `/assets/kitchen/0008/01.jpeg`,
      `/assets/kitchen/0008/02.jpeg`,
      `/assets/kitchen/0008/03.jpeg`,
      `/assets/kitchen/0008/04.jpeg`,
      `/assets/kitchen/0008/05.jpeg`,
      `/assets/kitchen/0008/06.jpeg`,
      `/assets/kitchen/0008/07.jpeg`,
      `/assets/kitchen/0008/08.jpeg`,
      `/assets/kitchen/0008/09.jpeg`,
    ],
  },
  {
    id: "0003",
    name: "Cozinha Graciosa",
    description: [
      "Surge o ousado desafio de uma cozinha suspensa num corredor movimentado da casa.\nA pedido do cliente, optamos por uma abordagem minimalista que faz sentir a elegância intemporal da ilha Graciosa, proporcionando uma experiência gastronómica serena e luxuosamente simples.",
      "O desejo de harmonizar a funcionalidade com a estética torna crucial o equilíbrio entre praticidade e beleza, transformando essa área de passagem em um espaço inesperado e acolhedor.",
      "O design minimalista e funcional otimiza o espaço, proporcionando uma história culinária prática e agradável."
    ],
    highlight: `/assets/kitchen/0003/01.jpeg`,
    assets: [
      `/assets/kitchen/0003/01.jpeg`,
      `/assets/kitchen/0003/02.jpeg`,
      `/assets/kitchen/0003/03.jpeg`,
      `/assets/kitchen/0003/04.jpeg`,
    ],
  },
  {
    id: "0007",
    name: "Cozinha Ancara",
    description: [
      "Uma cozinha que emana um requinte simplista em tons de branco e preto, fazendo transparecer a elegância  da cidade de Ancara. As suas linhas limpas e simples conferem à cozinha uma estética moderna e luxuosa, que faz enaltecer todo o seu  simplismo.",
      "A supremacia do branco cria uma sensação de amplitude e luminosidade, enquanto o preto adiciona um toque de mistério e refinamento. O equilíbrio criado, a pedido do cliente, resulta num espaço convidativo à simplicidade e ao luxo.",
      "Cada elemento foi atenciosamente escolhido para harmonizar com toda a arquitetura do espaço, originando uma cozinha que combina funcionalidade e classe com uma beleza discreta e requintada.",
    ],
    highlight: `/assets/kitchen/0007/01.jpeg`,
    assets: [
      `/assets/kitchen/0007/01.jpeg`,
      `/assets/kitchen/0007/02.jpeg`,
      `/assets/kitchen/0007/03.jpeg`,
      `/assets/kitchen/0007/04.jpeg`,
      `/assets/kitchen/0007/05.jpeg`,
      `/assets/kitchen/0007/06.jpeg`,
      `/assets/kitchen/0007/07.jpeg`,
      `/assets/kitchen/0007/08.jpeg`,
      `/assets/kitchen/0007/09.jpeg`,
      `/assets/kitchen/0007/10.jpeg`,
    ],
  },
];
